import axios from 'axios'

const loginiInstance = axios.create({
    // Heroku App need to allow cross orgin access to prod uction server // Allow-Cross-Orgin
    baseURL: ""+ process.env.REACT_APP_SF_LOGIN_URL +"",
    headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Accept": "application/json"
            },
    crossDomain: true,
    mode: 'CORS'
});


export default loginiInstance;
